angular.module("licensure.internal").directive("internalExamHeader", [
    function() {
        return {
            restrict: "E",
            templateUrl:
                paths.app + "components/headers/exam-header/exam-header.html",
            controller: [
                "$scope",
                "Permissions",
                function($scope, Permissions) {
                    $scope.getPermission = function(state, variable) {
                        Permissions.view(state).then(function(access) {
                            $scope[variable] = access;
                        });
                    };
                }
            ],
            replace: true,
            link: function(scope, elem, attrs, ctrl) {}
        };
    }
]);
